import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { trackButtonClick } from "../../services/googleSheetsService";

import PageTitle from "../../components/PageTitle/PageTitle";

import Profile_vita_1 from "../../assets/images/profile-vita-1.jpeg";
import Profile_vita_2_1 from "../../assets/images/main-logo-yellow.png";
import Profile_vita_2_2 from "../../assets/images/main-logo-blue.png";
import Profile_vita_2_3 from "../../assets/images/main-logo-navyBlue.png";
import Profile_vita_3 from "../../assets/images/instagram.png";

function AboutMaoMao() {
    return (
        <>
            <div className="content-section">
                <div className="container">
                    <PageTitle
                        titleTag={[]}
                        title={"關於喵喵問個痛"}
                        descriptionLines={["大家好，我是喵喵，平常叫Vita，江湖人稱貓女姐姐"]}
                    />

                    <div className="profile-wrap">
                        <div className="prolifeImg-wrap">
                            <img src={Profile_vita_1} alt="" />
                        </div>
                        <div className="profileText-wrap">
                            <h3>一隻任性的喵立志長成鯨魚喵！</h3>
                            <h4>馬拉松、三鐵、野跑多棲的女子，江湖人稱貓女姐姐</h4>
                            <p>
                                嗨大家好我是Vita，從2018年中憂鬱症好轉後因害怕肌少症而開始運動，太懼怕撞牆，於是努力研究各種不撞牆的方式。2018年底以台北馬完成初半馬、2019年初半馬破二、正式完成初馬成為百分之一的人類，並於同年成功全馬破四。而後與世界一起空白了兩年，換錯工作於是2022年完成初鐵Ironman70.3成為鐵喵，交錯朋友於是踏入越野，成為多棲生物。
                            </p>
                            <p>
                                近一年來身體出狀況，開始懂得取捨（或應該說放下）、越來越接受屬於自己的陰晴圓缺，與自己和解、並與世界達成某種動態平衡。因為有人說「小蝦米怎麼鬥得過大鯨魚」，而且畫出來的鯨魚喵很可愛，所以開始立志成為鯨魚喵，希望能夠變強壯來保護跟照顧身邊支持我的好朋友們，並始終保持溫暖與可愛，但需要的時候還是要機掰。
                            </p>
                        </div>
                    </div>
                    <div className="profile-wrap reverse">
                        <div className="prolifeImg-wrap profile-second">
                            <img
                                className="animate__animated animate__bounce animate__infinite animate__slower"
                                src={Profile_vita_2_1}
                                alt=""
                            />
                            <img
                                className="animate__animated animate__bounce animate__infinite animate__slow"
                                src={Profile_vita_2_2}
                                alt=""
                            />
                            <img
                                className="animate__animated animate__bounce animate__infinite animate__fast"
                                src={Profile_vita_2_3}
                                alt=""
                            />
                        </div>
                        <div className="profileText-wrap">
                            <h3>喵喵問個痛</h3>
                            <h4>我問痛，而且我喝＿＿＿＿</h4>
                            <p>
                                從剛開始運動的時候，臉書的發文就冠上「問痛」這個標題，除了與運動發音相似（哪裡！）另外就是覺得運動這是某種程度實在是件近乎自虐的行為，每每都是痛苦著且快樂著，想想也是跟「運動人的Pain
                                Cave」有異曲同工之妙（蹭個Windy跟老吳XD），於是這個網站名油然而生。而catvv.tw這個網址除了英文名字首字是v加上疊字比較可愛之外，vv成為w也有集眾人之合成為鯨魚whale的含意。
                            </p>
                        </div>
                    </div>
                    <div className="profile-wrap ">
                        <div className="profileText-wrap">
                            <h3>感謝來這裡玩的你妳</h3>
                            <h4>沒有沙發、只有原野跟草地，或許你可以找張自己喜歡的野餐墊</h4>
                            <p>
                                感謝在謎之演算法及茫茫資訊海之中，能夠與你以此種方式相遇。希望這只是一個開始，無論在人生或是運動的路上都能一起向前，以自己的配速與方向以某種方式彼此陪伴。
                            </p>
                            <p>
                                感謝工程師豪豪幫助我建造出這片有趣的天地，感謝我們的老婆（？）提供了很多很棒的建議（老婆永遠是對的），感謝我娘親你岳母（好亂的關係）的配速手環點子還有溫柔的力量扶持，感謝腿腿總是被我拉著討論一堆運動及行銷相關的點子，感謝翔翔常常陪我討論與運動及行銷不相關的鳥事。眾多朋友不及備載容我在見面時好好感謝你們。
                            </p>
                        </div>
                        <div className="profileIG-wrap">
                            <div className="IGtext-wrap">
                                <h3>最後、願我們都能擁抱自己的力量、 願喵喵可以擁有一些喵糧XD</h3>
                                <h4>你可以點擊右邊IG連結找到我</h4>
                            </div>
                            <div className="IGicon-wrap">
                                <a
                                    href="https://www.instagram.com/memoryflying/"
                                    onClick={() =>
                                        trackButtonClick(
                                            "關於喵喵-IG連結",
                                            "https://www.instagram.com/memoryflying/"
                                        )
                                    }
                                >
                                    <img src={Profile_vita_3} alt="貓女IG連結" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutMaoMao;
